<template>
  <el-dialog
    @close="close()"
    :title="$t('Missing_Features_Title')"
    :visible.sync="display"
    :modal-append-to-body="false"
    width="500px"
  >
    <div>
      <p>{{ $t('Missing_Features_Description') }}</p>
      <p>{{ $t('Missing_Features_Description_Line_Two') }}</p>
      <div class="m-top-10">
        <ul class="item-errors">
          <li v-for="item in flags">
            {{ getMissingFeatureLabel(item) }}
          </li>
        </ul>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" plain @click="close()">
        {{ $t('Missing_Features_Cancel') }}
      </el-button>
      <a :href="generateMailtoLink">
        <el-button size="small" type="primary">
          <span>{{ $t('PreMadeTemplatesTab_Btn_TalkToSales') }}</span>
          <i class="el-icon-arrow-right el-icon--right" />
        </el-button>
      </a>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'MissingFeaturesDialog',
  props: {
    flags: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      display: true,
      labels: {
        android_push: this.$t('Missing_Flag_Android_Push'),
        customer_intelligence_templates: this.$t(
          'Missing_Flag_Customer_Intelligence'
        ),
        customer_intelligence_promotion_page: this.$t(
          'Missing_Flag_Customer_Intelligence'
        ),
        email: this.$t('Missing_Flag_Email'),
        facebook: this.$t('Missing_Flag_Facebook'),
        inapp: this.$t('Missing_Flag_Inapp'),
        inapp_android: this.$t('Missing_Flag_Inapp_Android'),
        inapp_ios: this.$t('Missing_Flag_Inapp_Ios'),
        inbox: this.$t('Missing_Flag_Inbox'),
        ios_push: this.$t('Missing_Flag_Ios_Push'),
        maxautomation: this.$t('Missing_Flag_Maxautomation'),
        metabase: this.$t('Missing_Flag_Metabase'),
        onsite: this.$t('Missing_Flag_Onsite'),
        promotion: this.$t('Missing_Flag_Promotions'),
        sms: this.$t('Missing_Flag_Sms'),
        whatsapp: this.$t('Missing_Flag_Whatsapp'),
        webhook: this.$t('Missing_Flag_Webhook'),
        web_push: this.$t('Missing_Flag_Web_push'),
        workflow: this.$t('Missing_Flag_Maxautomation'),
        seed_list_enabled: this.$t('Missing_Flag_SeedList'),
        googleads: this.$t('Missing_Flag_GoogleAds'),
        meta: this.$t('Missing_Flag_Meta'),
        throttling: this.$t('Missing_Flag_Throttling'),
        microsites: this.$t('Missing_Flag_Mircosites'),
        rolling_segments: this.$t('Missing_Flag_RollingSegments')
      }
    }
  },
  computed: {
    generateMailtoLink() {
      return `mailto:account-management-team@xtremepush.com?subject=Pre-made templates feature request (${this.$store.state.app.project.name})`
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    getMissingFeatureLabel(item) {
      return this.labels[item] || item
    }
  }
}
</script>

<style scoped>
>>> .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  column-gap: 10px;
}
.item-errors {
  font-size: 14px;
  line-height: 22px;
  list-style: disc !important;
  padding-left: 18px;
}

li {
  word-break: normal;
}

li:first-letter {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/MissingFeaturesDialog.vue